/* eslint-disable class-methods-use-this */
/* eslint-disable no-console */
/* eslint-disable no-shadow */
/* eslint-disable react/forbid-prop-types */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import bindMethods from 'auto-bind';

import VideoPlayer from './VideoPlayer';
import { getPlayerInstance } from '../VirtualClipper/utils/videojs';
import { videoJsOptions } from '../VirtualClipper/constants/videoJsOptions';
import { addVideoSources, resetVideoSources } from '../VirtualClipper/state/videoSources';
import {
  resetVideoTimeStamp,
  updateMediaInformation,
  INVALID_VIDEO_MESSAGE,
} from '../../state/previewAsset';

// NOTE: error handling dependencies
import store from '../../../src/state/store';
import { getVideoType } from './utils/getVideoType';
import generatePreviewUrl from '../../utils/generatePreviewUrl';

class VideoContent extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);
  }

  async componentDidMount() {
    const {
      videoUrl, addVideoSources, resetVideoTimeStamp, updateMediaInformation,
      rawAssetDetails: { previewImageId },
    } = this.props;
    const vs = { src: videoUrl };
    const videoPlayer = getPlayerInstance();
    const posterUrl = generatePreviewUrl(previewImageId);

    addVideoSources(vs);
    if (posterUrl) {
      await videoPlayer.poster(posterUrl);
    }

    await videoPlayer.src(vs);

    resetVideoTimeStamp();

    videoPlayer.on('error', (e) => {
      const error = videoPlayer.error();
      const videoUrl = store.getState().videoSources.src;
      const hasDetectedVideoType = store.getState().videoSources.type;

      if (error.code === 4 && videoUrl) {
        if (hasDetectedVideoType) {
          console.log(
            '[QA] If you see this message, please double check if the video url is valid.',
          );
          updateMediaInformation({ type: null, source: null, message: INVALID_VIDEO_MESSAGE });
        } else {
          const unsupportedVideoType = getVideoType(videoUrl);
          console.log(
            `[QA] If you see this message, please ping XOS to support this video type: ${unsupportedVideoType}`,
          );
          updateMediaInformation({ type: null, source: null, message: INVALID_VIDEO_MESSAGE });
        }
      }
    });
  }

  async componentDidUpdate(prevProps) {
    const { videoUrl } = this.props;

    if (videoUrl !== prevProps.videoUrl) {
      const { addVideoSources, resetVideoTimeStamp, rawAssetDetails: { previewImageId } } = this.props;
      const vs = { src: videoUrl };
      const videoPlayer = getPlayerInstance();
      const posterUrl = generatePreviewUrl(previewImageId);

      addVideoSources(vs);
      await videoPlayer.poster(posterUrl);
      await videoPlayer.src(vs);
      resetVideoTimeStamp();
    }
  }

  componentWillUnmount() {
    const { resetVideoSources } = this.props;
    resetVideoSources();
  }

  render() {
    return <VideoPlayer {...videoJsOptions} />;
  }
}

VideoContent.propTypes = {
  rawAssetDetails: PropTypes.object.isRequired, // supplied from Redux
  videoUrl: PropTypes.string.isRequired, // supplied from MediaContent
  addVideoSources: PropTypes.func.isRequired, // supplied from Redux
  resetVideoSources: PropTypes.func.isRequired, // supplied from Redux
  resetVideoTimeStamp: PropTypes.func.isRequired, // supplied from Redux
  updateMediaInformation: PropTypes.func.isRequired, // supplied from Redux
};

const mapStateToProps = (state) => ({
  rawAssetDetails: state.rawAssetDetails,
});

const mapDispatchToProps = {
  addVideoSources,
  resetVideoSources,
  resetVideoTimeStamp,
  updateMediaInformation,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VideoContent);
